import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, Check } from "lucide-react";
import { subscribeNewsletter } from "../../lib/api";

// Compact public newsletter signup — no account required.
export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !/.+@.+\..+/.test(email)) { toast.error("Adresse e-mail invalide."); return; }
    setBusy(true);
    try { await subscribeNewsletter(email.trim(), true); setDone(true); toast.success("Merci ! Vous êtes abonné(e)."); }
    catch { toast.error("Échec de l'abonnement. Réessayez."); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-2xl border border-electric/25 bg-gradient-to-br from-surface/60 to-[#050505] p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6 justify-between" data-testid="newsletter-signup">
      <div className="max-w-md">
        <div className="text-[10px] tracking-[0.3em] uppercase text-electric mb-2 flex items-center gap-2"><Mail size={14} /> Newsletter</div>
        <h3 className="font-serif text-2xl md:text-3xl text-white leading-tight">Restez informé de nos projets, formations et du festival</h3>
      </div>
      {done ? (
        <div className="flex items-center gap-3 text-electric" data-testid="newsletter-signup-success">
          <div className="h-10 w-10 rounded-full bg-electric/15 border border-electric/40 flex items-center justify-center"><Check size={18} /></div>
          <span className="text-sm">Inscription confirmée. À bientôt !</span>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-wrap w-full md:w-auto gap-3">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.fr" data-testid="newsletter-signup-input"
            className="flex-1 min-w-0 md:w-64 bg-[#0e0e0e] border border-white/15 rounded-full px-5 py-3 text-white text-sm focus:border-electric outline-none" />
          <button type="submit" disabled={busy} data-testid="newsletter-signup-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-electric text-black text-[12px] tracking-[0.12em] uppercase font-semibold hover:bg-white transition-colors disabled:opacity-60 whitespace-nowrap">
            {busy ? <Loader2 size={15} className="animate-spin" /> : null} S'abonner
          </button>
        </form>
      )}
    </div>
  );
};
